import { render } from "./VisualFive.vue?vue&type=template&id=4feb7ef3"
import script from "./VisualFive.vue?vue&type=script&lang=js"
export * from "./VisualFive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__